export const bidangUsahaFormData = () => {
    return [
        {
            id: "bidang_usaha",
            label: "Bidang Usaha",
            fields: [{
                type: "input",
                placeholder: "Masukan Nama Bidang Usaha"
            }]
        }
    ]
}